const vibrate = async () => {
  if (navigator.vibrate) {
    navigator.vibrate(0);
    navigator.vibrate(8);
  }
};

export default vibrate;
